import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "tab",
    "facilityColumn",
    "matrixColumn",
    "emailColumn",
    "facilityHeader",
    "matrixHeader",
    "emailHeader",
    "idTypeInput",
  ];

  static values = { active: { type: String, default: "facility" } };

  connect() {
    this.boundRowsChanged = () => this._sync();
    this.element.addEventListener(
      "invite-producers-rows-changed",
      this.boundRowsChanged,
    );
    this._sync();
  }

  disconnect() {
    this.element.removeEventListener(
      "invite-producers-rows-changed",
      this.boundRowsChanged,
    );
  }

  show(event) {
    const idType = event.currentTarget.dataset.idType;
    if (!idType || idType === this.activeValue) return;

    this.activeValue = idType;
    this._sync();
    this.element.dispatchEvent(
      new CustomEvent("invite-producers-id-type-changed", {
        detail: { idType },
        bubbles: true,
      }),
    );
  }

  _sync() {
    const isFacility = this.activeValue === "facility";

    this.tabTargets.forEach((el) => {
      const active = el.dataset.idType === this.activeValue;
      el.setAttribute("aria-selected", active ? "true" : "false");
      el.classList.toggle("border-brand-600", active);
      el.classList.toggle("text-brand-700", active);
      el.classList.toggle("border-transparent", !active);
      el.classList.toggle("text-gray-500", !active);
    });

    this.facilityColumnTargets.forEach((el) => {
      this._setInputsEnabled(el, true);
    });
    this.matrixColumnTargets.forEach((el) => {
      el.classList.toggle("hidden", isFacility);
      this._setInputsEnabled(el, !isFacility);
    });
    this.emailColumnTargets.forEach((el) => {
      el.classList.toggle("hidden", !isFacility);
      this._setInputsEnabled(el, isFacility);
    });

    if (this.hasFacilityHeaderTarget) {
      this.facilityHeaderTarget.classList.remove("hidden");
    }
    if (this.hasMatrixHeaderTarget) {
      this.matrixHeaderTarget.classList.toggle("hidden", isFacility);
    }
    if (this.hasEmailHeaderTarget) {
      this.emailHeaderTarget.classList.toggle("hidden", !isFacility);
    }

    if (this.hasIdTypeInputTarget) {
      this.idTypeInputTarget.value = this.activeValue;
    }
  }

  _setInputsEnabled(container, enabled) {
    container.querySelectorAll("input, select, textarea").forEach((input) => {
      input.disabled = !enabled;
    });
  }
}
